// Validate the API reconciliation; never recompute or alter authoritative totals.
export function hasVerifiedPaymentTotal(reconciliation, summary) {
  return reconciliation?.state === 'available' &&
    Number.isSafeInteger(reconciliation.total) && reconciliation.total >= 0 &&
    ['available', 'pending_goods'].includes(summary?.finance_state) &&
    Number.isSafeInteger(summary.total_payment) && summary.total_payment >= 0 &&
    reconciliation.total === summary.total_payment;
}
